import { createFileRoute } from '@tanstack/react-router';
import { ReceiptPage } from '@/features/checkout/pages/receipt-page';

export const Route = createFileRoute('/_app/checkout/$billId/receipt')({ component: ReceiptRoute });

function ReceiptRoute() {
  const { billId } = Route.useParams();
  return <ReceiptPage billId={billId} />;
}
